'use client';
import React from 'react';

import { usePathname } from 'next/navigation';
import { useLocale } from 'next-intl';
import styled from 'styled-components';

import Link from '@/ui/components/Link';
import { urlBuilder } from '@/utils/urlBuilder';
import { addLocalePath } from '@/utils/urlBuilder/utils';

const LinkWrap = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'isActive',
}) <{ isActive: boolean }>`
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
  position: relative;

  &::before {
    background-color: ${({ theme }) => theme.custom.colors.brand};
    border-radius: 50%;
    content: '';
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
    height: 0.25rem;
    margin-right: 0.625rem;
    left: 0.3125rem;
    position: absolute;
    top: 18px;
    width: 0.25rem;
  }
`;

const LinkContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 9px 15px;
  /* align-items: center; */
  /* gap: 0.625rem; */
  align-self: stretch;
`;

const ItemDescription = styled.div`
  color: ${({ theme }) => theme.custom.colors.gray400};
  font-weight: normal;
`;

const LinkContent = ({ item }) => {
  if (item?.description) {
    return (
      <>
        <strong>
          <span>{item.title}</span>
        </strong>
        <ItemDescription>{item.description}</ItemDescription>
      </>
    );
  }

  return <span>{item.title}</span>;
};

export default function SideMenuItem({ item, active = false }) {
  const pathname = usePathname();
  const locale = useLocale();

  // const [hash, setHash] = React.useState('');

  // const handleHashChange = React.useCallback(
  //   event => {
  //     setHash(event.newURL.split('#')[1]);
  //   },
  //   [setHash]
  // );

  // React.useEffect(() => {
  //   window.addEventListener('hashchange', handleHashChange);

  //   return () => {
  //     window.removeEventListener('hashchange', handleHashChange);
  //   };
  // }, [handleHashChange]);

  const isActive = React.useMemo(() => {
    if (active) {
      return true;
    }

    if (!item) {
      return false;
    }

    if (item.slug) {
      return pathname === urlBuilder({ item, locale, silent: true });
    }

    return false;
  }, [active, item, pathname]);

  if (!item) {
    return null;
  }

  const content = (
    <LinkContentWrapper>
      <LinkContent item={item} />
    </LinkContentWrapper>
  );

  return (
    <LinkWrap isActive={isActive}>
      {item.type === 'useful_links' ? (
        <a href={item.content.replace(/<[^>]*>/g, '').trim()}>{content}</a>
      ) : item.type == 'directly_to_downloads' ? (
        <Link href={addLocalePath(locale, item.slug)}>{content}</Link>
      ) : (
        <Link item={item}>{content}</Link>
      )}
    </LinkWrap>
  );
}
